// Dependencies shared by mutation invalidation and WebSocket refreshes.
export const resourceTags = (url = '') => {
  const path = String(url).split('?')[0].replace(/^https?:\/\/[^/]+/, '').replace(/^\/api\//, '/');
  if (/^\/(employees|teams)\//.test(path)) return ['people'];
  if (/^\/(timesheets|manual-time|manual-time-entries|attendance-status|shifts|input-activities)\//.test(path)) return ['time'];
  if (/^\/(app-usage|activities|analytics|risk-users)\//.test(path)) return ['activity'];
  if (/^\/(screenshots|timelapse-videos)\//.test(path)) return ['media'];
  if (/^\/(leaves|leave-types|leave-balances|holidays)\//.test(path)) return ['leave'];
  if (/^\/(settings\/)?(alerts|notifications)\//.test(path)) return ['alerts'];
  if (path.startsWith('/settings/')) return ['settings'];
  if (/^\/(reports|scheduled-reports)\//.test(path)) return ['reports'];
  if (/^\/(projects|tasks)\//.test(path)) return ['projects'];
  if (path.startsWith('/payroll/')) return ['payroll'];
  if (path.startsWith('/billing/')) return ['billing'];
  return [path.split('/').filter(Boolean)[0] || 'other'];
};

const dependencies = {
  people: ['people', 'time', 'activity', 'reports', 'billing', 'payroll', 'projects', 'settings'],
  time: ['time', 'people', 'activity', 'reports', 'payroll', 'alerts'],
  activity: ['activity', 'reports', 'alerts'],
  media: ['media', 'billing'],
  leave: ['leave', 'people', 'time', 'reports', 'payroll', 'alerts'],
  settings: ['settings', 'people', 'time', 'activity', 'leave', 'media', 'reports', 'billing', 'payroll', 'projects'],
  billing: ['billing', 'settings'],
};

export const mutationTags = (url) => [...new Set(resourceTags(url).flatMap((tag) => dependencies[tag] || [tag]))];
export const eventTags = (event = '') => {
  if (/alert|notification/.test(event)) return ['alerts'];
  if (/setting|policy|employee|team/.test(event)) return mutationTags('/settings/');
  if (/leave|holiday/.test(event)) return mutationTags('/leaves/');
  if (/screenshot|timelapse/.test(event)) return mutationTags('/screenshots/');
  if (/risk|app|activity/.test(event)) return mutationTags('/app-usage/');
  return mutationTags('/timesheets/');
};

export const defaultRequestTtl = (url) => {
  // Access/track settings retain a short lifetime for policy changes.
  if (/^\/(holidays|settings\/rebrand|settings\/organization)\//.test(url)) return 60_000;
  if (/\/status\//.test(url)) return 0;
  return 15_000;
};
